'use client';

import * as React from 'react';
import { useSelectRootContext } from "../root/SelectRootContext.js";
import { useSelectItemContext } from "../item/SelectItemContext.js";
import { useRenderElement } from "../../utils/useRenderElement.js";
import { jsx as _jsx } from "react/jsx-runtime";
const InnerSelectItemText = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function InnerSelectItemText(componentProps, forwardedRef) {
  const {
    className,
    render,
    selected,
    selectedItemTextRef,
    indexRef,
    textRef,
    ...elementProps
  } = componentProps;
  const localRef = React.useCallback(node => {
    // Wait for the DOM indices to be set.
    queueMicrotask(() => {
      const hasNoSelectedItemText = selectedItemTextRef.current === null || !selectedItemTextRef.current.isConnected;
      if (selected || hasNoSelectedItemText && indexRef.current === 0) {
        selectedItemTextRef.current = node;
      }
    });
  }, [selected, selectedItemTextRef, indexRef]);
  const element = useRenderElement('div', componentProps, {
    ref: [localRef, forwardedRef, textRef],
    props: elementProps
  });
  return element;
}));

/**
 * A text label of the select item.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Select](https://base-ui.com/react/components/select)
 */
if (process.env.NODE_ENV !== "production") InnerSelectItemText.displayName = "InnerSelectItemText";
export const SelectItemText = /*#__PURE__*/React.forwardRef(function SelectItemText(props, forwardedRef) {
  const {
    selected,
    indexRef
  } = useSelectItemContext();
  const {
    selectedItemTextRef
  } = useSelectRootContext();
  const {
    textRef
  } = useSelectItemContext();
  return /*#__PURE__*/_jsx(InnerSelectItemText, {
    ref: forwardedRef,
    selected: selected,
    selectedItemTextRef: selectedItemTextRef,
    indexRef: indexRef,
    textRef: textRef,
    ...props
  });
});
if (process.env.NODE_ENV !== "production") SelectItemText.displayName = "SelectItemText";